export default __webpack_public_path__ + "static/productInfoManagementVp4-d0edd3d18364b4213365e6223260222b.png";